import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import { Wheel } from './components/Wheel';
import { WheelPrize } from './components/WheelPrize';
import './wheelPage.styl';
import { useStoreContext } from 'store/app';
import { useLocation } from 'react-router';
import { OverlayConfettiAnimation } from 'components/layout/overlayConfettiAnimation';

export const WheelPage = observer(() => {
    const [showPrize, setShowPrize] = useState(false);
    const { logOperation } = useStoreContext();
    const {
        state: { collectionId, missionId }
    } = useLocation() as { state: { collectionId: string; missionId: string } };

    useEffect(() => {
        logOperation('fortune', 'render', collectionId ? 'collection:' + collectionId : 'mission:' + missionId);
    }, []);

    return (
        <div className="container">
            <div
                className={cn('container-in-out', {
                    ['faded']: !showPrize
                })}
            >
                {showPrize ? <OverlayConfettiAnimation startDelay={500} /> : null}
                <WheelPrize />
            </div>
            <div
                className={cn('container-in-out', {
                    ['faded']: showPrize
                })}
            >
                <Wheel onShowPrize={() => setShowPrize(true)} />
            </div>
        </div>
    );
});
